import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 30px 24px;
  display: flex;
  justify-content: center;
  gap: 20px;
  background-color: #f8f9fa;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;

  .box {
    padding: 16px;
    border-radius: 4px;
    border: 1px solid #f1f3f5;
    background: #fff;
    width: 900px;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
    .header {
      margin-bottom: 16px;
      display: flex;
      justify-content: space-between;

      button {
        border-color: #228be6;
        color: #228be6;

        svg {
          path {
            stroke: #228be6;
          }
        }
      }

      .warning-text {
        display: flex;
        align-items: center;
        gap: 16px;
        border-radius: 4px;
        border: 1px solid #228be6;
        background: #fff;
        padding: 12px 12px 12px 16px;

        svg {
          path {
            stroke: #228be6;
          }
        }

        p {
          color: #25262b;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
        }
      }
    }

    .table {
      border: 1px solid #f1f3f5;
      border-radius: 8px;
      overflow: auto;
      flex: 1;
      min-height: 0;

      .table-header {
        border-bottom: 1px solid #f1f3f5;
        display: grid;
        grid-template-columns: 40px 1fr 1fr;

        padding-right: 8px;
        background-color: #f8f9fa;

        .th {
          &:first-child {
            max-width: 40px;
            padding: 12px 0;
            display: flex;
            justify-content: center;
          }

          &:first-child,
          &:nth-child(2) {
            border-right: 1px solid #f1f3f5;
          }

          padding: 12px 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .left-element {
            display: flex;
            align-items: center;
            gap: 4px;

            p {
              font-size: 14px;
              font-weight: 600;
              line-height: 19px;
              &:first-child {
                color: #868e96;
              }
              &:last-child {
                color: #495057;
              }
            }
          }

          .right-element {
            .aif-amount {
              color: #868e96;
              font-size: 14px;
              font-style: normal;
              font-weight: 600;
              line-height: 140%; /* 19.6px */
            }
          }
        }
      }
      .table-body {
        height: 100%;
        overflow: auto;

        .row {
          grid-template-columns: 40px 1fr 1fr;
          display: grid;
          border-bottom: 1px solid #f1f3f5;

          &:last-child {
            border-bottom: none;
          }
          .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            &.no-mapped {
              background: #f8f9fa;
              color: #adb5bd;
            }

            &:first-child,
            &:nth-child(2) {
              border-right: 1px solid #f1f3f5;
            }

            &:first-child {
              padding: 12px 0;
              justify-content: center;
            }

            button {
              padding: 0;
              border: none;
            }

            padding: 22px 16px;
            color: #000;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
          }
        }
      }
    }
  }
`;
